<script lang="jsx">
import Uploader from '../components/Uploader.vue'
import ReportDownloadsCard from '../components/ReportDownloadsCard.vue'
import { config } from '@/lib/helpers/config.helpers'
export default {
  components: {
    Uploader,
    ReportDownloadsCard,
  },
  render() {
    return (
      <div class="page">
        <h2>General</h2>
        <ul class="unstyled grid">
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/notPaidInvoices'}>
              <figure>
                <figcaption>Get unpaid invoices</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/getTodayBigEarners'}>
              <figure>
                <figcaption>Todays big earners</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/getYesterdayBigEarners'}>
              <figure>
                <figcaption>Yesterday big earners</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/getCostOnProvicers'}>
              <figure>
                <figcaption>Get cost on providers this month</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/getAllOneTimePayments'}>
              <figure>
                <figcaption>Get all one time payments.</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/getCostOnProvicersLastMonth'}>
              <figure>
                <figcaption>Get cost on providers last month</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard
              action={
                config.apiBaseUrl + '/customReports/numberOfUserCreatedTagPerDay?storeIds=127,25063,26025,25538,25062&startDate=2024-08-01'
              }
            >
              <figure>
                <figcaption>Get number of user created tag per day (Sinsay)</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
        </ul>
        <h2>Estimated this Month</h2>
        <ul class="unstyled grid">
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/SE'}>
              <figure>
                <figcaption>Estimated earning Sweden</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/PL'}>
              <figure>
                <figcaption>Estimated earning Poland</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/DE'}>
              <figure>
                <figcaption>Estimated earning Germany</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/DK'}>
              <figure>
                <figcaption>Estimated earning Denmark</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/NO'}>
              <figure>
                <figcaption>Estimated earning Norway</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/FR'}>
              <figure>
                <figcaption>Estimated earning France</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/IT'}>
              <figure>
                <figcaption>Estimated earning Italy</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/FI'}>
              <figure>
                <figcaption>Estimated earning Finland</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/GB'}>
              <figure>
                <figcaption>Estimated earning Great Britain</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/ES'}>
              <figure>
                <figcaption>Estimated earning Spain</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/NL'}>
              <figure>
                <figcaption>Estimated earning NL</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/CZ'}>
              <figure>
                <figcaption>Estimated earning Czech</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/SK'}>
              <figure>
                <figcaption>Estimated earning Slovakia</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/UA'}>
              <figure>
                <figcaption>Estimated earning Ukraine</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/RO'}>
              <figure>
                <figcaption>Estimated earning Romania</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/PT'}>
              <figure>
                <figcaption>Estimated earning Portugal</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
          <li class="card symetri">
            <ReportDownloadsCard action={config.apiBaseUrl + '/customReports/summaryEstimatedEarning/AU'}>
              <figure>
                <figcaption>Estimated earning Australia</figcaption>
              </figure>
            </ReportDownloadsCard>
          </li>
        </ul>
      </div>
    )
  },
}
</script>
